<template>
    <div class="registry-wrapper">
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="columns">
            <div class="column is-one-third">
                <search-bar :on-search="onSearch" tooltipLabel="msg-campo-busca-historico-email" />
            </div>
            <div v-if="permissao.update || permissao.create" class="column is-two-thirds is-flex">
                <div class="columns is-100">
                    <vss-select
                        class="column is-two-thirds"
                        :value="pedidosReenvio"
                        label="idpedidoerp"
                        title="pedidos"
                        :options="pedidos"
                        :loading="pedidosLoading"
                        :disabled="isResending"
                        @search="loadPedidos"
                        @input="selectPedidos"
                        multiple
                        searchable
                        clearable
                        :tooltipMultilined="true"
                        tooltipLabel="informacao-historico-email-pedido"
                        tooltipSize="is-large"
                        tooltipPosition="is-right"
                        :height="40"
                        :closeOnSelect="false"
                    >
                        <template #multiple-selected="{ selected }">
                            {{ $t('selecionar-pedidos-reenvio') }} ({{
                                selected ? selected.length : 0
                            }})
                        </template>
                        <template #option="{ option }">
                            <div :class="getStyle(option)">
                                <b-icon :icon="option.icone" />
                            </div>
                            <div>
                                <span>{{ option.idpedidoerp }}</span>
                                <span> - </span>
                                <span>{{ option.datahora | moment('L') }}</span>
                                <span> - </span>
                                <span>R$ {{ getDecimal(option.valortotal) }}</span>
                                <span> - </span>
                                <span>{{ option.tipopedido }}</span>
                            </div>
                        </template>
                    </vss-select>
                    <div class="column is-one-third">
                        <button
                            class="save-btn resend-btn ml-4"
                            :disabled="isResending"
                            @click="reenviarEmailPedidos"
                        >
                            {{ $t('reenviar-pedido') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <empty-table-message v-if="isEmpty" />
        <b-table
            v-else
            class="data-table"
            :class="{ 'disabled has-no-events': isLoading }"
            :data="data"
            detailed
            show-detail-icon
        >
            <b-table-column
                v-for="(f, i) in fields"
                class="td-center"
                :key="i"
                :field="f.key"
                :width="f.width"
                :centered="f.centered"
                :label="$t(f.label)"
                :sortable="f.sortable"
                v-slot="props"
            >
                <div v-if="f.key == 'status'">
                    <!-- Isto só é possível pq eu to ordenando o array de logs por datahora desc -->
                    <span v-if="props.row.logs && props.row.logs.length > 0">
                        {{ $t(props.row.logs[0].event) }}
                    </span>
                    <span v-else> – </span>
                </div>
                <div v-if="f.key == 'email'">
                    <!-- Idem status -->
                    <span v-if="props.row.logs && props.row.logs.length > 0">
                        {{ props.row.logs[0].email }}
                    </span>
                    <span v-else> – </span>
                </div>
                <div v-if="f.key == 'datahora'">
                    <!-- Idem status -->
                    <span v-if="props.row.logs && props.row.logs.length > 0">
                        {{ props.row.logs[0].created_at | moment('L LT') }}
                    </span>
                    <span v-else> – </span>
                </div>
                <div v-else>
                    {{ props.row[f.key] }}
                </div>
            </b-table-column>

            <template slot="detail" slot-scope="props">
                <div class="is-flex is-flex-hcenter">
                    <table class="table detail-email-table">
                        <tbody>
                            <tr v-for="l in props.row.logs" :key="l.id">
                                <td class="has-text-weight-bold">{{ $t(l.event) }}</td>
                                <td>{{ l.created_at | moment('L LT') }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>
        </b-table>
        <PaginationViewer
            class="mb-0"
            :resetPagination="pagination.resetPagination"
            :totalItems="pagination.totalRows"
            :perPageOptions="pagination.perPageOptions"
            :optionStarted="pagination.optionStarted"
            @change="updatePagination"
        />
    </div>
</template>

<script>
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import MailQueueService from '@/services/MailQueueService';
import VendasClienteService from '@/services/VendasClienteService';

export default {
    components: {
        ContainerLoader,
    },
    data() {
        return {
            id: this.$route.params.id,
            mailService: new MailQueueService(this.$http, this.$router),
            service: new VendasClienteService(this.$http, this.$router),
            fields: [
                { key: 'identificador', label: 'identificador', sortable: false },
                { key: 'idregistro', label: 'codigo', sortable: false },
                { key: 'status', label: 'status', sortable: false },
                { key: 'email', label: 'email', sortable: false },
                { key: 'datahora', label: 'data-hora', sortable: false },
            ],
            query: '',
            isResending: false,
            pedidosLoading: false,
            pedidosReenvio: [] /* Os pedidos que estão selecionados no combobox */,
            pedidos: [] /* As opções do combobox */,
            permissao: {},
            data: [],
            pedidosHasEmail: [],

            isEmpty: false,
            isLoading: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },

            isVenda: this.$route.meta.contexto == 'vendas',
            isAgro: this.$route.meta.contexto == 'agro',
            onSearch: null,
        };
    },
    created() {
        this.onSearch = this.debounce(function (query) {
            this.query = query;
            this.loadHistoricoEmail();
        }, 400);
        if (this.isVenda) {
            this.permissao = this.hasPermissionAccess(
                'vendas',
                'clientes',
                'ven-cliente-dados-cadastrais-historico-email'
            );
        } else if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0, 4);
            this.permissao = this.hasPermissionAccess(
                'agro',
                'clientes',
                'agro-cliente-dados-cadastrais-historico-email'
            );
        }

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'clientes' },
            });
        }

        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
    },
    methods: {
        loadPedidos(q) {
            this.pedidosLoading = true;

            this.service
                .getUltimosPedidos(this.id, 20, q)
                .then(this.mapItems)
                .then((r) => {
                    this.pedidos = r;
                    this.loadHistoricoEmailCount(q);
                })
                .then(() => {
                    this.loadHistoricoEmail();
                })
                .catch((e) => {
                    console.error('Erro ao carregar últimos pedidos.', e);
                })
                .finally((_) => {
                    this.pedidosLoading = false;
                });
        },

        mapItems(body) {
            return body.content.map((r) => {
                return {
                    id: r.id,
                    idpedido: r.idpedido,
                    idpedidoerp: r.idpedidoerp,
                    datahora: r.datahora,
                    tipopedido: r.tipopedido,
                    valortotal: r.valortotal,
                    hasEmail: false,
                    icone: 'email',
                };
            });
        },

        loadHistoricoEmail() {
            this.isLoading = true;
            let pedidoList = this.pedidos ? this.pedidos.map((e) => e.idpedidoerp) : [];

            this.mailService
                .getHistory(
                    this.id,
                    this.pagination.currentPage - 1,
                    this.pagination.perPage,
                    pedidoList,
                    this.query
                )
                .then((r) => {
                    this.data = r.content;
                    this.pagination.totalRows = r.totalElements;
                })
                .catch((e) => {
                    console.error('Erro ao carregar aba email', e);
                    this.$root.showMessage('error', 'msg-erro-ven-email-load');
                })
                .finally(() => {
                    this.isEmpty = !(this.data.length > 0);
                    this.isLoading = false;
                });
        },

        loadHistoricoEmailCount(query) {
            let pedidoList = this.pedidos ? this.pedidos.map((e) => e.idpedidoerp) : [];
            this.mailService
                .getHistoryCount(
                    this.id,
                    this.pagination.currentPage - 1,
                    this.pagination.perPage,
                    pedidoList,
                    query
                )
                .then((r) => {
                    this.pedidosHasEmail = r.content;
                })
                .catch((e) => {
                    console.error('Erro ao carregar aba email', e);
                    this.$root.showMessage('error', 'msg-erro-ven-email-load');
                });
        },

        reenviarEmailPedidos() {
            let ids = this.pedidosReenvio.map((e) => e.id);

            if (this.pedidosReenvio.length > 0) {
                this.isResending = true;
                this.mailService
                    .resendMail(ids)
                    .then((r) => {
                        this.pedidosReenvio = [];
                        this.$root.showMessage('success', 'msg-success-reenvio');
                    })
                    .catch((e) => {
                        console.error('Erro ao reenviar pedidos.', e);
                        this.$root.showMessage('success', 'msg-erro-reenvio');
                    })
                    .finally((_) => {
                        this.isResending = false;
                    });
            } else {
                this.$root.showMessage('alert', 'msg-nenhum-pedido-selecionado');
            }
        },

        getStyle(pedido) {
            let hasEmailClass = 'has-no-email';

            if (this.pedidosHasEmail) {
                this.pedidosHasEmail.forEach((p) => {
                    if (pedido.idpedidoerp == p.key && p.value > 0) {
                        hasEmailClass = 'has-email';
                        pedido.hasEmail = true;
                        return false;
                    }
                });
            }

            return hasEmailClass;
        },

        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.loadHistoricoEmail();
        },

        selectPedidos(pedido) {
            let tempList = [];
            let canSelect = 0;

            pedido.forEach((p) => {
                if (p.hasEmail) {
                    tempList.push(p);
                } else if (canSelect == 0) {
                    this.$root.showMessage('alert', 'msg-pedido-invalido-historico-email', true);
                    canSelect++;
                }
            });

            this.pedidosReenvio = tempList;
        },
    },
};
</script>

<style lang="scss" scoped>
.detail-email-table {
    max-width: 500px;

    td {
        width: 50%;
    }
}

.has-email {
    color: $green-alert;
}

.has-no-email {
    color: $red-alert;
}

.resend-btn {
    height: 40px;
    width: 100%;
    margin-top: 23px;
}
</style>
